import PanoramaFishEye from '@mui/icons-material/PanoramaFishEye';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function PanoramaFishEyeIcon(props: FixMe) {
  return <PanoramaFishEye {...props} />;
}

export default PanoramaFishEyeIcon;
